//dialog created to (before billing):
//create a shoot
//attach users to a position
//dialog reused for (after billing):
//in billing for attach a user to a solo estimate
//in billing for attach a user in the normal flow
//in billing to create a shoot from a solo estimate

import React from "react"
import { Dialog, DialogActions, Button, Hidden } from "@material-ui/core"
import { openSnackBar } from "../../actions/snack-bar"
import { connect } from "react-redux"
import {
  toggleShootDialog,
  setShootDialogCrew,
  createShootGlue,
  createCalendars,
  createMasterCalendar,
  updateCalendars,
  deleteShootGlue,
  getShootbyId,
  setRoleForCrew,
  addUserToRole,
  setActiveShootRole,
  updateShootRole,
  notifyGetShoots,
  recallShoot,
  updateShoot,
} from "../../actions/shoots"
import { udpateSoloRole, createSoloPositionCall } from "../../actions/solos"
import withMobileDialog from "@material-ui/core/withMobileDialog"
import { withStyles } from "@material-ui/core/styles"
import styles from "./styles"
import update from "immutability-helper"
import { getUsers } from "../../actions/misc"
import Context from "./context"
import { createShoot } from "../../actions/shoots"
import LoadingButton from "../LoadingButton"
import { getUser } from "../../actions/users"
import CreateUserDialog from "../CreateUserDialog/index"
import { find as _find, isEmpty, result } from "lodash"
import { withRouter } from "react-router"

import { clearCrewFromChip, getCrew } from "../../actions/crew"
import AddClientCompanyDialog from "../AddClientCompanyDialog/index"
import { createShootFromSolo } from "../../actions/solos"

let pages = []
const folder = require.context("./pages/", false, /\d+\.js$/)
folder.keys().map((x, i) => {
  const num = Number(x.match(/(\d)/)[0])
  pages[i] = { num, component: folder(x).default }
  return x
})

const defaultState = {
  shoot: {
    name: "",
    client: null,
    client_company: null,
    company_user_id: null,
    // call_time: orgDate
    //   .toISOString()
    //   .slice(0, 19)
    //   .replace("T", " "),
    call_time: null,
    start_date: new Date(),
    end_date: new Date(),
    day: "full",
    roles: [],
    newPosition: {
      switch: false,
      client_rate: 0,
      crew_rate: 0,
      available: false,
      requested: false,
    },
    location: null,
    firm: false,
    defaultCrews: [],
    timezone: "Eastern Time",

    forward_facing_text: "",
    creator_text: "",
    markConfirmDialog: false,
  },
  page: 1,
  saving: false,
  quickSaving: false,
  activeCompany: null,
  inCompany: false,
  positionRef: null,
  setClient: newClient => {
    this.shoot.client = newClient
  },
}

const whatToShow = all => {
  const page = all.state.page
  let component = null
  pages.map(x => {
    if (page === x.num) {
      component = React.createElement(x.component, {
        setState: e => all.setState(e),
        setRef: e => all.setState({ positionRef: e }),
      })
    }
    return x
  })
  return component
}

class ShootDialog extends React.Component {
  constructor(props) {
    super(props)

    this.state = defaultState
  }

  componentDidUpdate(prevProps) {
    if (prevProps.open === false && this.props.open === true) {
      this.props.users.length === 1 && this.props.dispatch(getUsers())
      // set client as the current user if they are not in a company
      if (
        typeof this.props.activeCompany !== "number" &&
        !this.state.shoot.client
      ) {
        this.setState(
          update(this.state, {
            shoot: {
              client: {
                $set: {
                  id: this.props.authenticatedUser.id,
                  full_name:
                    this.props.authenticatedUser.first_name +
                    " " +
                    this.props.authenticatedUser.last_name,
                },
              },
            },
          })
        )
      } else if (
        typeof this.props.activeCompany === "number" &&
        !this.state.inCompany
      ) {
        this.setState({ inCompany: true })
      }

      if (this.props.shootId) {
        const shoot = this.props.shoots.find(x => x.id === this.props.shootId)
        this.setState(
          update(this.state, {
            page: {
              $set: 2,
            },
            shoot: {
              id: {
                $set: this.props.shootId,
              },
              location: {
                $set: shoot.location,
              },
            },
          })
        )
      }
      //set page 2 if we open from solo to add a user to a role
      if (this.props.fromSolo && this.props.fromSolo.type === "add-crew") {
        this.setState(
          update(this.state, {
            page: {
              $set: 2,
            },
          })
        )
      }
      //set data from solo if we are creating a shoot from a solo estimate
      if (this.props.fromSolo && this.props.fromSolo.type !== "add-crew") {
        this.setState(
          update(this.state, {
            shoot: {
              client_company: {
                $set: this.props.fromSolo.data.client_company_id,
              },
              client_company_name: {
                $set: this.props.fromSolo.data.client_company_name,
              },
              company_user_id: {
                $set: this.props.fromSolo.data.client_id,
              },
              company_user_name: {
                $set: this.props.fromSolo.data.client_name,
              },
            },
          })
        )
      }
    }

    if (this.props.crew && !prevProps.crew) {
      this.props.crew.forEach((crew, i) => {
        this.props.dispatch(getUser(crew.id, false)).then(res => {
          this.setState(
            update(this.state, {
              shoot: {
                defaultCrews: {
                  [i]: {
                    $set: { ...this.state.shoot.defaultCrews[i], ...res },
                  },
                },
              },
            })
          )
        })
      })
      this.setState(
        update(this.state, {
          shoot: {
            defaultCrews: {
              $set: this.props.crew,
            },
          },
        })
      )
    }

    if (
      typeof this.props.activeCompany === "number" &&
      typeof prevProps.activeCompany !== "number"
    ) {
      this.setState(
        update(this.state, {
          activeCompany: {
            $set: this.props.activeCompany,
          },
          inCompany: {
            $set: true,
          },
        })
      )
    }
  }

  close = async bool => {
    // let shootId = window.location.pathname.match(/\d+/g).map(Number)

    if ((this.state.page === 1 || this.state.page === 2) && bool === true) {
      this.setState({ ...defaultState, page: this.state.page })
      this.props.dispatch(setShootDialogCrew(null))
      this.props.dispatch(setRoleForCrew())
      this.props.dispatch(toggleShootDialog({ open: false }))
      // this.props.dispatch(clearCrewFromChip())

      if (this.props.shootId) {
        const shoot = this.props.shoots.find(x => x.id === this.props.shootId)
        shoot.roles.forEach(role => {
          if (role.user_id) {
            this.props.dispatch(getCrew(role.user_id))
          }
        })
      }

      setTimeout(() => {
        this.setState({ page: 1 })
      }, 300)
    } else {
      await this.setState({ page: this.state.page - 1 })
    }
  }

  onPlacesChange = place => {
    this.setState(
      update(this.state, {
        location: {
          $set: place,
        },
      })
    )
  }

  next = () => {
    if (this.state.page === 1 || this.state.page === 3) {
      this.save()
    } else {
      this.setState({ page: this.state.page + 1 })
    }
  }

  update = async () => {
    const { state, props } = this
    const { shoot } = state

    const { roleSelected } = props

    this.setState({ saving: true })
    let data = shoot.roles
      .map(x => {
        return {
          user_id: null,
          role_id: x.position.id,
          client_rate: x.client_rate,
          crew_rate: x.crew_rate,
          available: false,
          requested: false,
        }
      })
      .concat(
        shoot.defaultCrews.map(x => {
          return {
            user_id: x.id,
            role_id: x.shootRole.id,
            client_rate: x.shootRole.client_rate,
            crew_rate: x.shootRole.crew_rate,
            available: x.shootRole.available,
            requested: x.shootRole.requested,
          }
        })
      )

    const newPosition = shoot.newPosition
    const confirm = shoot.markConfirmDialog

    if (
      !newPosition.position ||
      (!newPosition.crew_rate && newPosition.crew_rate !== 0) ||
      Number(newPosition.crew_rate) < 0 ||
      (!newPosition.client_rate && newPosition.client_rate !== 0) ||
      Number(newPosition.client_rate) < 0
    ) {
    } else {
      data = data.concat([
        {
          role_id: newPosition.position.id,
          client_rate: newPosition.client_rate,
          crew_rate: newPosition.crew_rate,
          user_id:
            newPosition.user && newPosition.user.id
              ? newPosition.user.id
              : null,
          requested: confirm,
          available: confirm,
        },
      ])
    }

    let promiseArr = []
    if (roleSelected) {
      let activeShootRole = this.props.activeShootRole

      //this if stament is to create a role with a user from add crew member
      if (!activeShootRole) {
        data.map(role => {
          promiseArr.push(
            this.props.dispatch(createShootGlue(shoot.id, "roles", role))
          )
        })
      } else {
        data.map(role => {
          promiseArr.push(
            this.props.dispatch(
              updateShootRole(shoot.id, activeShootRole, role)
            )
          )
          promiseArr.push(this.props.dispatch(setActiveShootRole()))
        })
      }
    } else {
      data.map(role => {
        promiseArr.push(
          this.props.dispatch(createShootGlue(shoot.id, "roles", role))
        )
      })
    }
    // This promiseArr has all of the roles including the new one the user just added
    await Promise.all(promiseArr)

    let createCalendarResponse = await this.props.dispatch(
      createCalendars(shoot.id)
    )

    if (createCalendarResponse && createCalendarResponse.message) {
      this.props.dispatch(
        openSnackBar({
          message: createCalendarResponse.message,
        })
      )
    }

    try {
      await this.props.dispatch(createMasterCalendar(shoot.id))

      this.props.dispatch(
        openSnackBar({
          message: "Added Event in User Master Calendar",
        })
      )
    } catch (err) {
      this.props.dispatch(
        openSnackBar({
          message: "Unable to Add Event in User Master Calendar",
        })
      )
    }

    try {
      await this.props.dispatch(updateCalendars(shoot.id))
    } catch (err) {
      this.props.dispatch(
        openSnackBar({
          message: "Unable to Update Calendar",
        })
      )
    }

    this.setState({ saving: false })
    if (window.location.pathname.includes("billing")) {
      // window.location.href = `/shoots/${shoot.id}/billing/deal-memo`
      this.props.history.push(`/shoots/${shoot.id}/billing/deal-memo`)
      // this.props
      //     .dispatch(
      //       updateShoot(shoot.id)
      //     )
      // I added these two lines below to fix the issue where adding a crew member
      // doesn't close the modal popup or load the new role until refresh
      // debugger;
      this.props.dispatch(toggleShootDialog({ open: false }))
      this.props.dispatch(recallShoot(true))
      this.props.dispatch(openSnackBar({ message: "New Crew Member Added" }))
    } else if (this.props.activeCompany) {
      // window.location.href = `/shoots/${shoot.id}`
      // this.props.history.push(`/shoots/${shoot.id}`);
      this.props.dispatch(recallShoot(true))
      setTimeout(() => {
        this.setState(defaultState)
        this.props.dispatch(toggleShootDialog({ open: false }))
        this.props.dispatch(recallShoot(false))
      }, 800)
    } else {
      this.props.history.push(`/my-shoots/${shoot.id}`)
    }
  }

  save = () => {
    const { state, props } = this
    const { shoot } = state

    const { activeCompany, authenticatedUser } = props
    // if shoot already exists
    if (shoot.id) {
      this.update()
      return
    }

    // end shoot already exists

    // if new shoot
    let shootCompanyFields = {}
    let shootCompanyFieldsData = {}

    if (!isEmpty(authenticatedUser.companies)) {
      shootCompanyFields =
        authenticatedUser.companies &&
        JSON.parse(
          result(
            _find(
              authenticatedUser.companies,
              company => (company.id === activeCompany ? activeCompany : 2)
            ),
            "shoot_fields"
          )
        )

      shootCompanyFields &&
        shootCompanyFields.forEach(
          field => (shootCompanyFieldsData[field] = null)
        )
    }

    this.setState({ saving: true })
    const newShoot = {
      name: shoot.name,
      start_date: shoot.start_date,
      end_date: shoot.end_date,
      call_time: shoot.call_time,
      full_day: shoot.day === "full" ? 1 : 0,
      location: JSON.stringify(shoot.location),
      firm: shoot.firm,
      timezone: shoot.timezone,
      creator_id: this.props.authenticatedUser.id,
      client_id: shoot.client && shoot.client.id ? shoot.client.id : null,
      company_id: this.props.activeCompany || 2,
      client_company: shoot.client_company,
      company_user_id: shoot.company_user_id,

      creator_text: shoot.creator_text,
      forward_facing_text: shoot.forward_facing_text,

      company_shoot_fields: !isEmpty(shootCompanyFieldsData)
        ? JSON.stringify(shootCompanyFieldsData)
        : null,
    }

    if (shoot.roles && shoot.roles.length > 0) {
      newShoot.glueData = {
        roles: shoot.roles.map(x => {
          return {
            role_id: x.position.id,
            client_rate: Number(x.client_rate),
            crew_rate: Number(x.crew_rate),
            user_id: null,
            available: 0,
            requested: 0,
          }
        }),
      }
    }
    if (shoot.defaultCrews && shoot.defaultCrews.length > 0) {
      const data = shoot.defaultCrews.map(x => {
        return {
          role_id: x.shootRole.id,
          client_rate: x.shootRole.client_rate,
          crew_rate: x.shootRole.crew_rate,
          user_id: x.id,
          requested: x.shootRole.requested ? 1 : 0,
          available: x.shootRole.available ? 1 : 0,
        }
      })
      if (newShoot.glueData) {
        newShoot.glueData.roles = newShoot.glueData.roles.concat(data)
      } else if (data.length > 0) {
        newShoot.glueData = {
          roles: data,
        }
      }
    }

    const newPosition = shoot.newPosition
    if (
      !newPosition.position ||
      (!newPosition.crew_rate && newPosition.crew_rate !== 0) ||
      Number(newPosition.crew_rate) < 0 ||
      (!newPosition.client_rate && newPosition.client_rate !== 0) ||
      Number(newPosition.client_rate) < 0
    ) {
    } else {
      const arr = [
        {
          role_id: newPosition.position.id,
          client_rate: newPosition.client_rate,
          crew_rate: newPosition.crew_rate,
          user_id:
            newPosition.user && newPosition.user.id
              ? newPosition.user.id
              : null,
          requested: newPosition.requested ? 1 : 0,
          available: newPosition.available ? 1 : 0,
        },
      ]
      if (newShoot.glueData) {
        newShoot.glueData.roles = newShoot.glueData.roles.concat(arr)
      } else {
        newShoot.glueData = {
          roles: arr,
        }
      }
      this.props.dispatch(clearCrewFromChip())
    }
    let shootId = null
    //if we create a shoot from solo we need to add one promise
    if (!this.props.fromSolo || this.props.fromSolo.type !== "add-crew") {
      this.props
        .dispatch(createShoot(newShoot))
        .then(res => {
          shootId = res.shoots[0].id
          if (this.props.fromSolo) {
            let type = this.props.fromSolo.data.estimate_id
              ? "estimate"
              : "invoice"
            let soloId = this.props.fromSolo.data.estimate_id
              ? this.props.fromSolo.data.estimate_id
              : this.props.fromSolo.data.invoice_id
            return Promise.all([
              this.props.dispatch(createShootFromSolo(type, soloId, shootId)),
              this.props.dispatch(createCalendars(shootId)),
              this.props.dispatch(createMasterCalendar(shootId)),
            ])
            // Below was commented out for some reason so it stopped making calendar events so I added it back
          } else {
            return Promise.all([
              this.props.dispatch(createCalendars(shootId)),
              this.props.dispatch(createMasterCalendar(shootId)),
            ])
          }
          // else {
          //   return Promise.all([
          //     this.props.dispatch(createCalendars(shootId)),
          //     this.props.dispatch(createMasterCalendar(shootId)),
          //   ])
          // }
        })
        .then(() => {
          this.setState({ saving: false })
          // this.props.dispatch(getShoots())
          this.close(true)

          if (this.props.activeCompany) {
            // window.location.href = "/shoots/" + shootId

            this.props.history.push(`/shoots/${shootId}`)
          } else {
            // window.location.href = "/my-shoots/" + shootId
            this.props.history.push(`/my-shoots/${shootId}`)
          }
        })
        .catch(err => {
          this.setState({ saving: false })
          console.log(err)
        })
    }
    //if we add a crew to a position in solo
    if (this.props.fromSolo && this.props.fromSolo.type === "add-crew") {
      let selectedRoleId = this.props.roleSelected.id //if creating solo crew member this will be null
      let data = {
        user_id: this.state.shoot.defaultCrews[0].id,
      }
      let soloIdAndType = this.props.fromSolo.role.estimate_id
        ? { soloId: this.props.fromSolo.role.estimate_id, type: "estimate" }
        : { soloId: this.props.fromSolo.role.invoice_id, type: "invoice" }
      // SOLO - Create Crew Member role & Assign or just assigne to previously created role
      if (!this.props.roleSelected.id) {
        // if creating generic solo crew member - creates role & assigns user to it
        let requestPayload = { role_id: this.props.fromSolo.role.role_id }
        this.props
          .dispatch(
            createSoloPositionCall(
              soloIdAndType.type,
              soloIdAndType.soloId,
              requestPayload
            )
          )
          .then(async res => {
            selectedRoleId = res.data[0].id
            // Crew Member role created, now assigning
            await this.props
              .dispatch(
                udpateSoloRole(soloIdAndType.type, selectedRoleId, data)
              )
              .then(newRes => {
                this.props.fromSolo.setSoloData(oldState => {
                  let newRole = {
                    shoot_role: newRes.data[0].id,
                    name: this.props.roleSelected.name,
                    expenses: [],
                    ...newRes.data[0],
                  }
                  return {
                    ...oldState,
                    roles: [...oldState.roles, newRole],
                  }
                })
              })
            this.setState({ saving: false })
            this.setState({ ...defaultState, page: this.state.page })
            this.props.dispatch(setShootDialogCrew(null))
            this.props.dispatch(setRoleForCrew())
            this.props.dispatch(toggleShootDialog({ open: false }))
            setTimeout(() => {
              this.setState({ page: 1 })
            }, 300)
          })
          .catch(err => {
            this.setState({ saving: false })
            this.setState({ ...defaultState, page: this.state.page })
            this.props.dispatch(setShootDialogCrew(null))
            this.props.dispatch(setRoleForCrew())
            this.props.dispatch(toggleShootDialog({ open: false }))
            console.log(err)
            setTimeout(() => {
              this.setState({ page: 1 })
            }, 300)
          })
      } else {
        // solo role created separately, only assigning crew member to it.
        this.props
          .dispatch(udpateSoloRole("invoice", selectedRoleId, data))
          .then(res => {
            this.props.fromSolo.setSoloData(oldState => {
              return {
                ...oldState,
                roles: oldState.roles.map(role => {
                  if (role.shoot_role === res.data[0].id) {
                    return {
                      shoot_role: res.data[0].id,
                      name: this.props.roleSelected.name,
                      expenses: role.expenses,
                      ...res.data[0],
                    }
                  } else {
                    return role
                  }
                }),
              }
            })
            this.setState({ saving: false })
            this.setState({ ...defaultState, page: this.state.page })
            this.props.dispatch(setShootDialogCrew(null))
            this.props.dispatch(setRoleForCrew())
            this.props.dispatch(toggleShootDialog({ open: false }))
            setTimeout(() => {
              this.setState({ page: 1 })
            }, 300)
          })
          .catch(err => {
            this.setState({ saving: false })
            this.setState({ ...defaultState, page: this.state.page })
            this.props.dispatch(setShootDialogCrew(null))
            this.props.dispatch(setRoleForCrew())
            this.props.dispatch(toggleShootDialog({ open: false }))
            console.log(err)
            setTimeout(() => {
              this.setState({ page: 1 })
            }, 300)
          })
      }
    }
  }

  quickSave = () => {
    // Save and DON'T GO happens here
    const { state } = this
    const { shoot } = state
    if (shoot.id) {
      this.update()
      return
    }
    this.setState({ quickSaving: true })
    const newShoot = {
      name: shoot.name,
      start_date: shoot.start_date,
      end_date: shoot.end_date,
      call_time: shoot.call_time,
      full_day: shoot.day === "full" ? 1 : 0,
      location: JSON.stringify(shoot.location),
      firm: shoot.firm,
      timezone: shoot.timezone,
      creator_id: this.props.authenticatedUser.id,
      client_id: shoot.client && shoot.client.id ? shoot.client.id : null,
      company_id: this.props.activeCompany || 2,
      client_company: shoot.client_company,
      company_user_id: shoot.company_user_id,

      creator_text: shoot.creator_text,
      forward_facing_text: shoot.forward_facing_text,
    }

    let shootId = null
    this.props
      .dispatch(createShoot(newShoot))
      .then(res => {
        shootId = res.shoots[0].id
        if (this.props.fromSolo) {
          let type = this.props.fromSolo.estimate_id ? "estimate" : "invoice"
          let soloId = this.props.fromSolo.estimate_id
            ? this.props.fromSolo.estimate_id
            : this.props.fromSolo.invoice_id
          return Promise.all([
            this.props.dipsacth(createShootFromSolo(type, soloId, shootId)),
            this.props.dispatch(createCalendars(shootId)),
            this.props.dispatch(createMasterCalendar(shootId)),
          ])
        } else {
          return Promise.all([
            this.props.dispatch(createCalendars(shootId)),
            this.props.dispatch(createMasterCalendar(shootId)),
          ])
        }
      })
      .then(res => {
        this.setState({ quickSaving: false })

        this.setState(defaultState)

        this.props.dispatch(notifyGetShoots(true))

        this.props.dispatch(toggleShootDialog({ open: false }))

        setTimeout(() => {
          this.props.dispatch(notifyGetShoots(false))
        }, 1000)
      })
      .catch(err => {
        this.setState({ quickSaving: false })
        console.log(err)
      })
  }

  render() {
    const { open, classes } = this.props

    return (
      <Context.Provider value={this.state}>
        {/* WEB VIEW */}
        <Hidden smDown>
          <Dialog
            className={classes.crewDialog}
            open={open}
            onClose={e => this.close(true)}
            maxWidth={this.state.page === 2 ? "lg" : false}
            fullWidth={this.state.page === 2 ? true : false}
            disableBackdropClick
          >
            {/* disableBackdropClick */}
            {whatToShow(this)}
            <DialogActions>
              <Button
                color="primary"
                onClick={() => this.close(true)}
                // disabled={Boolean(this.state.shoot.id)}
              >
                {this.state.page === 1 || this.state.page === 2
                  ? "Cancel"
                  : "Back"}
              </Button>
              {this.state.page == 1 && (
                <LoadingButton
                  variant="contained"
                  color="primary"
                  onClick={this.quickSave}
                  disabled={whatToShow(this).type.allowNext(this.state)}
                  working={this.state.quickSaving}
                >
                  {/* {this.state.page === pages.length ? "Save" : "Next"} */}
                  Save
                </LoadingButton>
              )}

              <LoadingButton
                variant="contained"
                color="primary"
                onClick={this.next}
                disabled={whatToShow(this).type.allowNext(this.state)}
                working={this.state.saving}
              >
                {this.state.page === 1 && "Save and Open"}
                {this.state.page === 2 && "Next"}
                {this.state.page === 3 && "Save"}
              </LoadingButton>
            </DialogActions>
          </Dialog>
        </Hidden>
        {/* MOBILE VIEW */}
        <Hidden mdUp>
          <Dialog
            className={classes.crewDialog}
            fullScreen
            open={open}
            onClose={e => this.close(true)}
            maxWidth={false}
          >
            {/* disableBackdropClick */}
            {whatToShow(this)}
            <DialogActions>
              <Button
                color="primary"
                onClick={() => this.close(true)}
                // disabled={Boolean(this.state.shoot.id)}
              >
                {this.state.page === 1 || this.state.page === 2
                  ? "Cancel"
                  : "Back"}
              </Button>
              {this.state.page == 1 && (
                <LoadingButton
                  variant="contained"
                  color="primary"
                  onClick={this.quickSave}
                  disabled={whatToShow(this).type.allowNext(this.state)}
                  working={this.state.quickSaving}
                >
                  {/* {this.state.page === pages.length ? "Save" : "Next"} */}
                  Save
                </LoadingButton>
              )}
              <LoadingButton
                variant="contained"
                color="primary"
                onClick={this.next}
                disabled={
                  this.state.quickSaving
                    ? true
                    : whatToShow(this).type.allowNext(this.state)
                }
                working={this.state.saving}
              >
                {this.state.page === 1 && "Save and Open"}
                {this.state.page === 2 && "Next"}
                {this.state.page === 3 && "Save"}
              </LoadingButton>
            </DialogActions>
          </Dialog>
        </Hidden>
        {open && (
          <CreateUserDialog
            onSaveUser={res => {
              this.setState(
                update(this.state, {
                  shoot: {
                    newPosition: {
                      user: {
                        $set: {
                          full_name: res.first_name + " " + res.last_name,
                          id: res.id,
                        },
                      },
                    },
                  },
                })
              )
            }}
          />
        )}
        <AddClientCompanyDialog
          origin="create_shoot"
          onSaveUser={res => {
            this.setState(
              update(this.state, {
                shoot: {
                  client_company: {
                    $set: res.id,
                  },
                },
              })
            )
          }}
        />
      </Context.Provider>
    )
  }
}

ShootDialog.contextType = Context

const mapStateToProps = state => {
  return {
    open: state.shoots.showDialog,
    shootId: state.shoots.dialogShootId,
    shoots: state.shoots.shoots,
    crew: state.shoots.dialogCrew,
    users: state.misc.users,
    activeCompany: state.companies.activeCompany,
    authenticatedUser: state.authentication.authenticatedUser,
    roleSelected: state.shoots.roleSelected,
    activeShootRole: state.shoots.activeShootRole,
    fromSolo: state.shoots.dialogData,
  }
}

const connector = connect(mapStateToProps)

export default withRouter(
  withStyles(styles, { withTheme: true }, withMobileDialog())(
    connector(ShootDialog)
  )
)
